import React from 'react';
import { Users, UserPlus, UserCheck, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';

export default function HRISStats({ stats }) {
  const statCards = [
    {
      label: 'Total Pegawai',
      value: stats.totalEmployees,
      subLabel: `${stats.activeEmployees} aktif`,
      subColor: 'text-emerald-600',
      icon: Users,
      iconColor: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      borderColor: 'border-l-emerald-500',
    },
    {
      label: 'Hadir Hari Ini',
      value: stats.todayPresent,
      subLabel: `${stats.todayAbsent} tidak hadir`,
      subColor: 'text-red-600',
      icon: UserCheck,
      iconColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
      borderColor: 'border-l-blue-500',
    },
    {
      label: 'Pengajuan Cuti',
      value: stats.pendingLeaves,
      subLabel: 'menunggu approval',
      subColor: 'text-amber-600',
      icon: Calendar,
      iconColor: 'text-amber-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-l-amber-500',
    },
    {
      label: 'Rekrutmen',
      value: stats.pendingRecruitment,
      subLabel: 'dalam proses',
      subColor: 'text-purple-600',
      icon: UserPlus,
      iconColor: 'text-purple-600',
      bgColor: 'bg-purple-50',
      borderColor: 'border-l-purple-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statCards.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          <div
            className={`bg-white rounded-lg border shadow-sm border-l-4 ${stat.borderColor} p-4`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500">{stat.label}</p>
                <p className="text-2xl font-bold">{stat.value}</p>
                <p className={`text-xs ${stat.subColor} mt-1`}>{stat.subLabel}</p>
              </div>
              <div
                className={`w-12 h-12 rounded-xl ${stat.bgColor} flex items-center justify-center`}
              >
                <stat.icon className={`w-6 h-6 ${stat.iconColor}`} />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}
